
export const loanJourneyEventDescriptions = {
  loan_login_viewed: "Login page opened",
  loan_login_submit_clicked: "User submitted the login form",
  loan_otp_viewed: "OTP verification page opened",
  loan_otp_verify_clicked: "User submitted the OTP",
  loan_type_selection_viewed: "Loan type selection page opened",
  loan_type_continue_clicked: "User picked a loan type and continued",
  loan_treatment_details_viewed: "Treatment details page opened",
  loan_treatment_details_continue_clicked: "User submitted treatment details",
  loan_patient_info_viewed: "Patient info page opened",
  loan_patient_info_continue_clicked: "User submitted patient info",
  loan_personal_details_viewed: "Personal details page opened",
  loan_personal_details_continue_clicked: "User submitted personal details",
  loan_address_details_viewed: "Address details page opened",
  loan_address_details_continue_clicked: "User submitted address details",
  loan_employment_details_viewed: "Employment details page opened",
  loan_employment_details_continue_clicked: "User submitted employment details",
  loan_personal_loan_message_viewed: "Personal loan message page opened",
  loan_personal_loan_message_cta_clicked: "User tapped the CTA on the personal loan message page",
  loan_lender_success_viewed: "Lender success page opened",
  loan_lender_success_cta_clicked: "User tapped the CTA on the lender success page",
  loan_sanctioned_viewed: "Loan sanctioned page opened (terminal screen, no CTA)",
  loan_error_viewed: "Error page opened",
  loan_error_retry_clicked: "User tapped retry/back on the error page",
};
